module.exports = __webpack_public_path__ + "images/32179a26ed0375eaf0642cc7d0cb69142.svg";